import { render, staticRenderFns } from "./CatologueProducts.vue?vue&type=template&id=237358ce&"
import script from "./CatologueProducts.vue?vue&type=script&lang=js&"
export * from "./CatologueProducts.vue?vue&type=script&lang=js&"
import style0 from "./CatologueProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports